export const FeaturedCountries = [
  'at',
  'be',
  'ch',
  'de',
  'es',
  'fi',
  'fr',
  'is',
  'it',
  'nl',
  'pt',
];
